import { userRepository } from '@/service/repository/userRepository'
import { cookieManager } from '@/service/cookieManager'

const state = {
	user: null,
	userReservations: []
}

const getters = {
	firstReservation(state) {
		const allReservations = [...state.userReservations]
		allReservations.sort((a, b) => {
			const dateA = new Date(a.startDateTime)
			const dateB = new Date(b.startDateTime)
			return dateA - dateB
		})

		return allReservations.length > 0 ? allReservations[0] : false
	},
	user(state) {
		return state.user
	}
}

const mutations = {
	setUser(state, payload) {
		state.user = payload.user
	},
	loadUserReservations(state, payload) {
		state.userReservations = payload.userReservations
	},
	eraseReservation(state, payload) {
		state.userReservations = state.userReservations.filter(
			reservation => reservation.id !== payload.reservationId
		)
	}
}

const actions = {
	async find({ commit }, userId) {
		try {
			const findUserResult = await userRepository.find(userId)
			if (findUserResult.result === 0) {
				commit('setUser', findUserResult)
				cookieManager.setToken(findUserResult.token)
				return findUserResult
			} else {
				cookieManager.clearToken()
				return findUserResult
			}
		} catch (error) {
			return alert(error)
		}
	},

	async loginWithToken({ commit }, { token, app = null } = {}) {
		try {
			const findUserResult = await userRepository.loginWithToken(token, app)
			if (findUserResult.result === 0) {
				commit('setUser', findUserResult)
				cookieManager.setToken(findUserResult.token)
				return findUserResult
			} else {
				cookieManager.clearToken()
				return findUserResult
			}
		} catch (error) {
			return alert(error)
		}
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions
}
